// 🚨 AUTO-GENERADO desde BuyInvoicePaymentDataType.ts - No editar manualmente

export const BuyInvoicePaymentFormDataKeys = [
  "id",
  "descripcion",
  "monto",
  "vuelto",
  "formaPago",
  "digitosTarjeta",
  "numAprobacion",
  "estado",
  "exchange_rate",
  "created",
  "recibo",
  "cobrador",
  "providerRecibeId",
  "currencyId",
  "currency",
  "bankAccountId",
  "creditOperatorId",
  "buyInvoiceId",
  "buyInvoice"
] as const;
